// Puerto del dominio (repository abstracto) para la consulta de tarifas.
// Un solo método agrega los 3 productos vigentes (mismo patrón que
// InitialDataRepository.getAllInitialData(), ver docs/architecture/ARCHITECTURE.md §5) — el adaptador resuelve
// el forkJoin de las 3 llamadas en paralelo.
import { Observable } from 'rxjs';
import { PlanRateResult } from '../../interfaces/tarifa/tarifa.interface';

export abstract class TarifaRepository {
  abstract getAllPlanRates(leadId: string): Observable<PlanRateResult[]>;
}
